/*
import convert from 'xml-js'

export default function (data, props) {
    let result = convert.xml2js(data, {
        //ignoreCdata: true,
        ignoreComment: true,
        compact: true
    });

    if(result.items) {
        if (result.items.item[0]) {
            props.title = result.items.item[0].title._cdata;
            props.content = result.items.item[0].description._cdata;
            props.imageUrl = (result.items.item[0].image._cdata + '').split(';')[0];
        } else if (result.items.item.title) {
            props.title = result.items.item.title._cdata;
            props.content = result.items.item.description._cdata;
            props.imageUrl = (result.items.item.image._cdata + '').split(';')[0];
        }
    }
}
*/

export default function (data, props) {
    if(data.success && data.result) {
        props.title = data.result.name.replace('&#8211;','-');
        props.content = data.result.short_desc;
        props.imageUrl = data.result.image_url;
    }
}
